import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

/**
 * Pure controlled form for {@link MachineCategoryAssignDto}: a single
 * category-id selector.
 *
 * Shape: {@code { categoryId: number | null }}.
 *
 * {@code categories} is data — the caller fetches the list once (via
 * {@code GET /api/categories}) and hands it in. The form itself has no
 * side effects.
 */
const MachineCategorySelectForm = ({value, onChange, categories}) => {
    return (
        <FormControl fullWidth size="small">
            <InputLabel id="machine-category-label">Category</InputLabel>
            <Select
                labelId="machine-category-label"
                label="Category"
                value={value?.categoryId ?? ''}
                onChange={(e) => onChange({categoryId: e.target.value})}
            >
                {categories.map((c) => (
                    <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MachineCategorySelectForm;
